import { Component, OnInit } from '@angular/core';
import { ContentPage } from 'src/app/enums/content-page.enum';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {
  nosotros = ContentPage.esES.nosotros;
  constructor() { }

  ngOnInit() {
    let language = localStorage.getItem('language');
    if (language == 'esEN') {
      this.nosotros = language == 'esEN' ? ContentPage.esEN.nosotros : ContentPage.esEN.nosotros;
    }
  }

}
